import type invitationZh from '../zh/invitation';

const invitation: typeof invitationZh = {
  title: 'Lời mời',
  create_target: 'Tạo lời mời định hướng',
  create_target_soon: 'Sắp chuyển sang TikTok Shop để tạo Target Collab',
  cleanup: 'Dọn lời mời định hướng',
  merge_groups: 'Gộp nhóm lời mời',
  add_talent: 'Thêm KOL',
  remove_talent: 'Xóa KOL',
  remove_talent_soon: 'Xóa KOL khỏi các lời mời đã chọn',
  remove_talent_title: 'Xóa KOL chưa chấp nhận',
  remove_talent_hint:
    'Trước tiên đọc KOL từ chi tiết lời mời. Đã chấp nhận và chưa chấp nhận lấy từ nhãn của KOL. Khi gửi vẫn có thể bị bỏ qua và trả về lý do.',
  label_accepted: 'Đã chấp nhận',
  label_unaccepted: 'Chưa chấp nhận',
  label_ordered: 'Đã có đơn',
  remove_talent_failed: 'Không xóa được KOL',
  remove_talent_success: 'Đã gửi yêu cầu xóa KOL',
  remove_no_unaccepted: 'Hiện không có KOL chưa chấp nhận lời mời',
  cleanup_remove_none: 'Không còn KOL để xóa',
  add_product: 'Thêm sản phẩm',
  kaloboost_hint: 'Theo Kaloboost: lời mời lấy Target Collab phía cửa hàng làm chuẩn, không dùng hạn mức tin nhắn',
  status_tabs: 'Trạng thái lời mời',
  col_name: 'Tên lời mời (TikTok Shop)',
  col_status: 'Trạng thái',
  col_product: 'Sản phẩm',
  col_deadline: 'Hạn chót',
  col_added: 'KOL đã thêm',
  col_accepted: 'Đã chấp nhận',
  col_fulfilled: 'Đã thực hiện',
  col_actions: 'Thao tác',
  filter_all: 'Tất cả',
  name_placeholder: 'Tìm tên lời mời',
  submit_status: 'Trạng thái gửi',
  filter_ongoing: 'Đang diễn ra',
  filter_closed: 'Đã hết hạn',
  filter_cancelled: 'Đã hủy',
  status_expiring: 'Sắp hết hạn',
  status_valid: 'Còn hiệu lực',
  status_canceling: 'Đang hủy',
  status_completed: 'Đã hoàn thành',
  submit_submitting: 'Đang gửi',
  submit_success: 'Đã gửi',
  submit_failed: 'Thất bại',
  submit_unknown: 'Không rõ',
  load_failed: 'Không tải được danh sách lời mời',
  batch_invite_hint: 'Tối đa 10 lời mời. KOL trong danh sách chặn và KOL đã có trong lời mời sẽ được bỏ qua.',
  invite_shop_required: 'Vui lòng chọn cửa hàng trước',
  invite_pick_required: 'Vui lòng chọn lời mời',
  invite_options_failed: 'Không tải được danh sách lời mời',
  invite_success: 'Đã gửi lời mời hàng loạt',
  invite_failed: 'Mời hàng loạt thất bại',
  refreshed: 'Đã làm mới danh sách sản phẩm cửa hàng',
  pick_product: 'Vui lòng chọn ít nhất một sản phẩm',
  product_list_unavailable: 'Chưa có giao diện danh sách sản phẩm',
  add_products_failed: 'Không thêm được sản phẩm',
  add_products_success: 'Đã thêm sản phẩm',
  add_products_limit: 'Chọn tối đa 10 lời mời',
  invite_limit: 'Chọn tối đa 10 lời mời',
  target_named: '"{{name}}"',
  target_current: 'lời mời hiện tại',
  added_products: 'Đã thêm {{count}} sản phẩm vào {{target}}',
  add_product_title: 'Thêm sản phẩm vào lời mời',
  product_hint:
    'Chỉ sản phẩm đang bán của cửa hàng đã ủy quyền. Hoa hồng mặc định theo tỷ lệ lời mời công khai, có thể chỉnh cho lời mời định hướng.',
  current_shop: 'Cửa hàng hiện tại',
  rate_adjustable: 'Hoa hồng mặc định theo tỷ lệ lời mời công khai, có thể chỉnh',
  refresh: 'Làm mới',
  public_rate: '{{sku}} · {{price}} · Lời mời công khai {{rate}}%',
  target_commission: 'Hoa hồng định hướng',
  has_email: 'Có email',
  no_email: 'Không có email',
  pick_talent: 'Vui lòng chọn ít nhất một KOL',
  added_talents: 'Đã thêm {{count}} KOL vào {{target}}',
  add_talent_title: 'Thêm KOL vào lời mời',
  add: 'Thêm',
  talent_hint: 'Ưu tiên chọn từ KOL của tôi. Tự động bỏ qua danh sách đen / đã có trong lời mời / bị khóa trùng đơn.',
  none_selected: 'Chưa chọn KOL. Chọn từ KOL của tôi, hoặc tìm ở quảng trường để thêm.',
  selected_count: 'Đã chọn {{count}} KOL',
  selected_named: 'Đã chọn {{count}} KOL · {{name}}',
  search_placeholder: 'Tìm KOL của tôi, hoặc nhập biệt danh / @handle để tìm ở quảng trường',
  my_talents: 'KOL của tôi ({{count}})',
  search_square: 'Tìm quảng trường',
  paste_list: 'Dán danh sách',
  select_all: 'Chọn tất cả kết quả',
  paste_placeholder: 'Mỗi dòng một biệt danh hoặc @handle',
  square_prompt: 'Nhập biệt danh hoặc @handle để tìm KOL ở quảng trường',
  no_match: 'Không có KOL phù hợp',
  mode_clear_title: 'Xóa KOL chưa chấp nhận và hủy lời mời trống',
  mode_clear_desc:
    'Chỉ xóa KOL chưa chấp nhận. KOL đã chấp nhận được giữ. Lời mời hết sản phẩm và 0 lượt chấp nhận sẽ tự hủy.',
  mode_cancel_title: 'Hủy kế hoạch lời mời',
  mode_cancel_desc: 'Kết thúc toàn bộ Target Collab ngay cả khi đã có KOL chấp nhận. Cần xác nhận lần hai.',
  cleaned: 'Đã dọn: {{mode}}',
  cleaned_whitelist: 'Đã dọn: {{mode}} (danh sách trắng {{count}} người)',
  confirm_cancel_title: 'Xác nhận hủy kế hoạch lời mời?',
  confirm_cancel_content: 'Kết thúc toàn bộ Target Collab ngay cả khi đã có KOL chấp nhận. Thao tác này không thể hoàn tác.',
  confirm_cancel_ok: 'Xác nhận hủy',
  confirm_cancel_back: 'Quay lại',
  cancel_plan_failed: 'Không hủy được kế hoạch lời mời',
  cancel_plan_success: 'Đã hủy kế hoạch lời mời',
  run_cleanup: 'Thực hiện dọn',
  choose_method: 'Chọn cách dọn',
  whitelist_title: 'KOL không dọn (danh sách trắng)',
  whitelist_summary: 'Danh sách trắng đã chọn {{count}} KOL (sẽ được giữ khi dọn)',
  stat_added: 'Đã thêm',
  deadline_at: 'Hạn {{date}}',
  talents: 'KOL',
  accepted_note: 'Sau khi chấp nhận sẽ vào thực hiện;',
  pending_note: 'Chưa chấp nhận thì có thể dọn. Không chiếm hạn mức tin nhắn.',
  detail_title: 'Chi tiết lời mời',
  detail_load_failed: 'Không tải được chi tiết lời mời',
  detail_empty: 'Chưa có chi tiết lời mời',
  detail_empty_talents: 'Chưa có KOL',
  detail_content_products: 'Sản phẩm nội dung',
  detail_empty_products: 'Chưa có sản phẩm',
  detail_empty_operations: 'Chưa có nhật ký thao tác',
  detail_sync_pending: 'Chưa đọc lại được trạng thái mới nhất. Số liệu bên dưới có thể chưa phải trạng thái hiện tại.',
  detail_failed_reason: 'Lý do thất bại',
  detail_submit_failed: 'Gửi thất bại: {{reason}}',
  detail_shop_id: 'ID cửa hàng',
  detail_deadline: 'Hạn chót',
  detail_free_sample: 'Mẫu miễn phí',
  detail_sample_exempt: 'Miễn duyệt',
  detail_content_type: 'Loại nội dung',
  detail_operations: 'Nhật ký thao tác',
  detail_op_failed: 'Thao tác gần nhất thất bại',
  detail_request_id: 'Mã yêu cầu nền tảng',
  detail_yes: 'Có',
  detail_no: 'Không',
  pick_primary: 'Vui lòng chọn lời mời chính',
  pick_deadline: 'Vui lòng chọn hạn chót sau khi gộp',
  pick_two: 'Vui lòng chọn ít nhất 2 lời mời đang diễn ra và chưa khóa',
  merged: 'Đã gộp {{count}} lời mời vào "{{name}}", hạn {{date}}',
  merge_failed: 'Không gộp được lời mời',
  merge_success: 'Đã gộp lời mời',
  merge_end_invalid: 'Hạn chót phải muộn hơn thời điểm hiện tại',
  merge: 'Gộp',
  merge_hint:
    'Gộp nhiều lời mời định hướng đang diễn ra và chưa khóa thành một. KOL và sản phẩm được khử trùng rồi ghi vào lời mời chính.',
  too_few: 'Trong các lời mời đã chọn cần ít nhất 2 mục Đang diễn ra và chưa khóa mới gộp được.',
  primary: 'Lời mời chính',
  primary_placeholder: 'Chọn lời mời chính',
  deadline_after: 'Hạn chót sau khi gộp',
  channel_email: 'Email nền tảng',
  channel_dm: 'Tin nhắn',
  script_sample: 'Dùng thử sản phẩm mới',
  script_invite: 'Lời mời định hướng',
  script_follow: 'Theo dõi phản hồi',
  outreach_created: 'Đã tạo nhiệm vụ kết nối ({{count}} người)',
  outreach_title: 'Kết nối nhanh',
  create_task: 'Tạo nhiệm vụ',
  task_name: 'Tên nhiệm vụ',
  task_name_placeholder: 'Để trống sẽ dùng "Nhiệm vụ email"',
  mail_subject: 'Chủ đề email',
  mail_subject_placeholder: 'Nhập chủ đề email',
  mail_body: 'Nội dung email',
  mail_body_placeholder: 'Nhập nội dung email',
  template_placeholder: 'Không bắt buộc, chỉ mẫu email của cửa hàng hiện tại',
  template_load_failed: 'Không tải được mẫu tin',
  campaign_subject_required: 'Vui lòng nhập chủ đề email',
  campaign_body_required: 'Vui lòng nhập nội dung email',
  campaign_no_email: 'KOL đã chọn không có email, không tạo được nhiệm vụ',
  campaign_skipped_email: 'Đã bỏ qua {{count}} KOL không có email',
  campaign_failed: 'Không tạo được nhiệm vụ email',
  campaign_created: 'Đã tạo nhiệm vụ email',
  dm_failed: 'Không tạo được hội thoại tin nhắn',
  dm_missing_conversation: 'Không nhận được mã hội thoại',
  dm_created: 'Đã tạo hội thoại tin nhắn',
  channel: 'Kênh',
  script_or_invite: 'Mẫu tin / Lời mời',
  select_talent: 'Chọn KOL',
  all_count: 'Tất cả ({{count}})',
  empty_selected: 'Chưa có KOL được chọn. Hãy chọn từ tab khác.',
  batch_count: 'Hàng loạt {{count}} người',
  joined: 'Đã thêm vào lời mời định hướng: {{name}}',
  join_title: 'Thêm vào lời mời định hướng',
  join_title_named: 'Thêm vào lời mời định hướng · {{name}}',
  invite: 'Lời mời',
  target_hint: 'Ghi vào Target Collab của cửa hàng hiện tại. Qua danh sách đen và khóa trùng đơn.',
  invite_list: 'Danh sách lời mời',
  invite_list_placeholder: 'Chọn lời mời',
  create_name: 'Tên lời mời',
  create_name_placeholder: 'VD: VN tinh chất vitamin C · tháng 10',
  create_deadline: 'Hạn chót',
  mounted_products: 'Sản phẩm gắn kèm',
  product_load_failed: 'Không tải được sản phẩm cửa hàng',
  product_pick_invite: 'Vui lòng chọn lời mời trước',
  product_empty: 'Cửa hàng hiện chưa có sản phẩm bán',
  product_keyword: 'Tìm tên sản phẩm',
  product_refreshed: 'Đã làm mới sản phẩm cửa hàng',
  add_talent_section: 'Thêm KOL (chọn nhanh từ KOL của tôi)',
  talent_default_hint: 'Mặc định chỉ dùng "KOL của tôi". Quảng trường cần tìm rồi thêm, không tải toàn bộ.',
  submit_invite: 'Gửi lời mời',
  submit_invite_note:
    'Sau khi gửi sẽ tạo Target Collab trên TikTok Shop. KOL thấy lời mời ở phía Seller / liên minh, chấp nhận rồi vào thực hiện. Cửa hàng cần đã ủy quyền. KOL trong danh sách đen không xuất hiện.',
  create_name_required: 'Vui lòng nhập tên lời mời',
  create_deadline_required: 'Vui lòng chọn hạn chót',
  contact_email: 'Email liên hệ',
  contact_email_placeholder: 'Nhập email liên hệ',
  contact_email_required: 'Vui lòng nhập email liên hệ',
  invite_message: 'Nội dung lời mời',
  invite_message_placeholder: 'Không bắt buộc',
  commission_required: 'Vui lòng nhập hoa hồng từ 0 trở lên',
  product_id_invalid: 'Mã sản phẩm không được để trống và không quá 64 ký tự',
  create_failed: 'Không tạo được lời mời',
  create_success: 'Đã tạo lời mời',
  create_skipped: 'Đã bỏ qua {{count}} KOL'
};

export default invitation;
